import { SetPasswordType } from '@api/types';
import { useSetPasswordMutation } from '@config/state/globalSlices/apiSlice/mutations';
import { createNotification } from '@shared/utils/createNotification';
import { Form,Formik } from 'formik';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useParams } from 'react-router-dom';

import AuthHeader from '../Components/AuthHeader';
import Input from '../Components/Input';
import SubmitButton from '../Components/SubmitButton';
import { passwordFormSchema } from '../schemas';

const initialValues = {
  password: '',
  confirmPassword: '',
};

export default function SetPassword() {

  const navigate = useNavigate();
  const { rc, u } = useParams();

  const [submitSetPasswordForm, { isLoading: isSubmitting, isSuccess }] = useSetPasswordMutation();

  const handleSubmit = async (values: typeof initialValues) => {
    try {
      const val = {
        username: u,
        newPassword: values.password,
        resetCode: rc,
      } as SetPasswordType;
      await submitSetPasswordForm(val).unwrap();

      createNotification({
        message: 'Your password has been successfully changed',
        type: 'success',
      });
      navigate('/ap/login');

    } catch (error){
      createNotification({
        message: 'Your password reset token may have expired. Please request a new reset',
        type: 'error',
      });
    }
  };

  return (
    <div className="w-full">

      <Helmet title="PHMG | Change Password" />
      <AuthHeader title="Set new password" />
      <Formik initialValues={initialValues} onSubmit={handleSubmit} validationSchema={passwordFormSchema}>
        {({ errors }) => (
          <Form className='text-[14px]'>
            <Input error={errors?.password} label="New password" name='password' placeholder="" type="password" showToggle />
            <Input error={errors?.confirmPassword} label="Confirm password" name="confirmPassword" showToggle placeholder="" type="password" />

            <SubmitButton text="Set new password" type="submit" disabled={isSubmitting || isSuccess} />
          </Form>)}
      </Formik>

    </div>)

}
